import React, { Component } from 'react';
import './sensorDevice.less';
import { Switch } from 'antd';
import PubSub from 'pubsub-js'
import { meshLog, SPRemove, SPGet, SPSet } from "../../../../../utils/spUtils";
import { getDevicesByGroupId } from '../../../../../utils/meshUtils';
import { convertSecondsToTime } from '../../../../../utils/dataUtils';
import { sendOpcode_group_light, sendOpcode_group_onoff, sendOpcode_identify, sendOpcode_group_state, sendOpcode_devices_state } from '../../../../../utils/opcodeUtils';
import montion from "../../../../../imgs/item/montion.png";
import devices from "../../../../../imgs/item/devices.png";
import btn_refresh from "../../../../../imgs/btn/btn_refresh.png";
import arrow_right from "../../../../../imgs/btn/arrow_right.png";
import arrow_down from "../../../../../imgs/btn/arrow_down.png";
import eye_show from "../../../../../imgs/btn/eye_show.png";
import wifi_4 from "../../../../../imgs/mesh/wifi_4.png";
import wifi_0 from "../../../../../imgs/mesh/wifi_0.png";
import { IsDevicePir } from '../../../../../utils/pidUtils';
import { SET_ControlPageDetailPage_DIALOG_HIDE } from "../../../../../const/infoConst"


export default class SensorDevice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checked: false, //group是否展开
            devices: [], //group数据

        }
    }



    componentDidMount() {
        this.updateGroupUI();
        PubSub.subscribe('updateGroupdataUI', (msg, data) => {
            this.updateGroupUI();
        })

        PubSub.unsubscribe("mqttGroupState")
        PubSub.subscribe('mqttGroupState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
        meshLog('更新灯的状态',);
        PubSub.unsubscribe("mqttDeviceState")
        PubSub.subscribe('mqttDeviceState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
    }

    updateGroupUI() {
        meshLog('group渲染第一步', this.props);
        const groupInfo = JSON.parse(SPGet("groupInfo"))
        this.setState({
            // groupDevices: groupDevices,
            devices: getDevicesByGroupId(groupInfo.groupID), //group数据
        })
    }

    //group展开
    groupArrowClick = () => {
        let mm = this.state.checked;
        this.setState({ checked: !mm });
    }

    controlRefreshDevices = () => {
        //获取单灯的状态，通过网关来返回的
        sendOpcode_devices_state()
        meshLog('获取单灯的状态',);
    }

    vacantOk = () => {
        //关闭这个弹框，打开sensor界面
        PubSub.publish('gotoSensorset', '')//显示Sensorset界面
    }

    //显示SensorDeviceControl界面
    gotoSensorDeviceControl = (device) => {
        SPSet('controlDevice', JSON.stringify(device))
        PubSub.publish('gotoSensorDeviceControl', '')
        PubSub.publish(SET_ControlPageDetailPage_DIALOG_HIDE, device)//控制ControlPageDetailPage弹框显示

    }

    render() {
        const { } = this.state;

        return (
            <div className="sensorDevice-container">
                <div className="sensorDevice-ui_grey_bg" />
                <div className="sensorDevice-popup">
                    <div style={{ marginTop: "20px" }}>
                        <span style={{ marginLeft: "20px", fontSize: "18px" }}>Single Device Control</span>
                        {/* <img className="refresh-icon" onClick={() => { this.controlRefreshDevices() }} src={btn_refresh} /> */}
                        {/* 灯数据 */}
                    </div>

                    {/* 灯数据 */}
                    <div className="sensorDevice-line_space"></div>
                    <div className="sensorDevice-title" >
                        <div className="title1">Device Location</div>
                        <div className="title2">Location</div>
                        <div className="title2">Status</div>
                        <div className="title3">Operation</div>
                    </div>
                    <div style={{ height: "550px", overflow: "auto" }}>
                        {this.state.devices.map((device) => (
                            <div className="sensorDevice-date" key={device.macAddress} style={{ display: IsDevicePir(device.pid) ? "flex" : "none" }} >
                                <div className='title1' >
                                    {device.name}
                                </div>
                                <div className='title2'>
                                    <img className='img' onClick={() => { this.showHightLight(device) }} src={eye_show} />
                                </div>
                                <div className='title2'>
                                    <img className='img' src={device.online == 1 ? wifi_4 : wifi_0} />
                                </div>
                                <div className='title3'>
                                    <button className='btns' onClick={() => this.gotoSensorDeviceControl(device)} >Control </button>
                                </div>
                            </div>
                        ))}


                    </div>
                    {/* 底部按钮 */}
                    <div className="sensorDevice-control-footer">
                        <button className='cancelBtn' onClick={() => this.vacantOk()}>Cancel</button>
                        <button className='okBtn' onClick={() => this.vacantOk()} >Confirm</button>
                    </div>


                </div>

            </div >
        );
    }
}
